import { useEffect, useState } from "react";
import styles from "./users.module.css";
import OrderDetails from "./OrderDetails";
import OrderInvoice from "./OrderInvoice";
import OrderStatus from "./OrderStatus";
import { useSelector } from "react-redux";
import SidebarField from "../../../components/Sidebar/SidebarField";
import ChatComponent from "../../../components/Socket/ChatUI";
import masterApi from "../../../apis/master.api";
import { PackageApi } from "../../../apis/ProductListing.apis";

const OrderModal = ({ handleCloseOrderModal, isOrderDetail, orderData,pagination,search }) => {
  const [toggleContent, setToggleContent] = useState("Details");
  const [isFullWidth, setIsFullWidth] = useState(false)
   const [units, setUnits] = useState([]);
  const [packageData, setPackageData] = useState([]);

   const allUnits = async () => {
    try {
      const res = await masterApi.getAllUnitMaster();
      // adjust path if needed
      setUnits(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

   const getPackageData = async () => {
      try {
        const res = await PackageApi.getAllPackageMaster();
        const subcategoriesData =
          res.data?.data.length &&
          res.data?.data.map((o, i) => {
            o.value = o._id;
            o.label = o?.packaging_name;
            return o;
          });
  
        setPackageData(subcategoriesData);
      } catch (err) {
         console.error(err);
      } finally {
      }
    };

    const getUnitName = (unitId) => {
    if (!unitId || !units.length) return "";
    const unit = units.find((u) => u._id === unitId);
    return unit?.unit || unit?.unit_name || "";
  };

   const getPackageName = (id) => {
  if (!id || !packageData?.length) return "";
  const pkg = packageData.find((p) => p._id === id);
  return pkg?.packaging_name || "";
};


  useEffect(() => {
    allUnits();
    getPackageData();
  }, []);

  const { theme } = useSelector((state) => state.theme);
  if (isOrderDetail) {
    return (
      <>
        <SidebarField footer={false} handleClose={() => handleCloseOrderModal()} title={`Order Details`}>
          <div style={{ display: "flex" }}>
            {["Details", "Invoice", "Status", "Chat"].map((item) => (
              <hr
                style={{
                  width: "25%",
                  borderTop:
                    item === toggleContent ? "5px solid  " : "1px solid",
                  color:
                    item === toggleContent
                      ? "rgb(15 61 100 / var(--tw-text-opacity)"
                      : "var(--light-color3)",
                  borderRadius: "10px",
                  borderBottom: "none",
                  borderLeft: "none",
                  borderRight: "none",
                }}
              />
            ))}
          </div>

          <div className={`${styles.content_list}  border-black-700 `}>
            {["Details", "Invoice", "Status", "Chat"].map((item) => (
              <span
                onClick={() => setToggleContent(item)}
                style={{
                  color:
                    item === toggleContent
                      ? "var(--color--2) "
                      : "var(--light-color3)",
                  cursor: "pointer",
                }}
              >
                {item}
              </span>
            ))}
          </div>
          <hr />
          {toggleContent === "Details" && (
            <OrderDetails
              getUnitName={getUnitName}
              getPackageName={getPackageName}
              deliveryAddress={orderData?.delivery_address}
              orderDetails={orderData?.orderDetails}
              orderData={orderData}
              pagination={pagination}
              search={search}
              handleCloseOrderModal={handleCloseOrderModal}
            />
          )}
          {toggleContent === "Invoice" && (
            <OrderInvoice invoiceData={orderData} />
          )}
          {toggleContent === "Status" && (
            <OrderStatus orderData={orderData} />
          )}
          {/* {toggleContent === "Chat" && <OrderChat />} */}
          {toggleContent === "Chat" && <ChatComponent data={orderData} />}
        </SidebarField>
      </>
    );
  }
};

export default OrderModal;
